export const cssOverrides = `
  .dynamic-footer {
    display: none;
  }
  .connect-button {
    background: #346df6 !important;
    color: #fff;
    font-family: "Arboria Medium";
    padding: 15px 4%;
    border: 1px solid transparent;
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    vertical-align: middle;
    border-radius: 50px;
    width: 100%;
  }
  .connect-button:hover:enabled {
    border: 1px solid transparent;
  }

  .connect-button.button--primary .typography {
    font-family: "Arboria Medium";
    font-size: 1.3rem !important;
    color: #fff;
  }
  .dynamic-widget-inline-controls {
    background: #346df6 !important;
    font-size: 1.3rem !important;
    padding: 1px;
    line-height: 1.5;
    border-radius: 50px;
    max-height: none;
  }

  .dynamic-widget-inline-controls .typography--body-small {
    font-size: 1.3rem !important;
  }
`;

export default cssOverrides;
